/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nodealsmatchfilters4Inputs */

const en_coinvestments_nodealsmatchfilters4 = /** @type {(inputs: Coinvestments_Nodealsmatchfilters4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No deals match the selected filters. Try adjusting your search criteria.`)
};

/**
* | output |
* | --- |
* | "No deals match the selected filters. Try adjusting your search criteria." |
*
* @param {Coinvestments_Nodealsmatchfilters4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nodealsmatchfilters4 = /** @type {((inputs?: Coinvestments_Nodealsmatchfilters4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nodealsmatchfilters4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nodealsmatchfilters4(inputs)
});
export { coinvestments_nodealsmatchfilters4 as "coInvestments_noDealsMatchFilters" }